import React from "react";

// Fixed grain overlay to add texture across the whole app.
export function NoiseOverlay() {
  return <div className="noise-overlay" aria-hidden="true" />;
}
